var _path;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgIcoSun(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 28,
    height: 28,
    viewBox: "0 0 28 28",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M14 1V2.44444M14 25.5556V27M27 14H25.5556M2.44444 14H1M23.1924 23.1924L22.1712 22.1712M5.82878 5.82878L4.80756 4.80756M23.1924 4.80756L22.1712 5.82878M5.82878 22.1712L4.80756 23.1924M19.7778 14C19.7778 15.5324 19.169 17.002 18.0855 18.0855C17.002 19.169 15.5324 19.7778 14 19.7778C12.4676 19.7778 10.998 19.169 9.91449 18.0855C8.83095 17.002 8.22222 15.5324 8.22222 14C8.22222 12.4676 8.83095 10.998 9.91449 9.91449C10.998 8.83095 12.4676 8.22222 14 8.22222C15.5324 8.22222 17.002 8.83095 18.0855 9.91449C19.169 10.998 19.7778 12.4676 19.7778 14V14Z",
    stroke: "black",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgIcoSun);
export default __webpack_public_path__ + "static/media/ico_sun.57b1da887bd464ec766775999f89ff68.svg";
export { ForwardRef as ReactComponent };